// extracted by mini-css-extract-plugin
export default {"section":"d4bMs","container":"k8FAI ZdH1P","titleWrapper":"oz1vL","title":"m0VTl","priceMin":"ooWcW","items":"bcHKq","gallery":"YM5aR","track":"eDF0R","item":"PpNAP","stub":"yxEoM"};